import inputKey from './inputKey'
import showKey from '../cnConst/showKey'
import executeKey from './executeKey'

const defaultValue = new Map(
  [
    [inputKey.search,inputKey.baidu]
    ,[inputKey.video,inputKey.youku]
    ,[inputKey.music,inputKey.qqmusic]
    ,[inputKey.mv,inputKey.qqmusicmv]
    ,[inputKey.play,inputKey.playQQMusic]
    ,[inputKey.question,inputKey.zhihu]
    ,[inputKey.wiki,inputKey.baidubaike]
    ,[inputKey.news,inputKey.baiduxinwen]
    ,[inputKey.playMv,inputKey.playQQMusicMv]
    ,[inputKey.buy, inputKey.taobao]
    ,[inputKey.code, inputKey.github]
    ,[inputKey.airticket,inputKey.feizhuairticket]
    ,[inputKey.trainticket,inputKey.feizhutrainticket]
    ,[executeKey.notExecute,showKey.xzNot]
    ,[executeKey.executing,showKey.xzing]
    ,[executeKey.executeSuccess,showKey.xzSuccess]
    ,[executeKey.executeWarning,showKey.xzWarning]
    ,[executeKey.executeError,showKey.xzError]
  ]
)
export default defaultValue



// WEBPACK FOOTER //
// ./src/cnConst/defaultValue.js